const inspection = {
  inspection: "Kiểm tra kho",
  draft: "Nháp",
  pending: "Đang tiến hành",
  resolved: "Hoàn thành",
  rejected: "Đã hủy",
  plState: "Vui lòng chọn trạng thái đơn kiểm tra",
  state: "Trạng thái",
  number: "Số đơn kiểm tra",
  createdAt: "Thời gian tạo",
  updatedAt: "Thời gian thao tác",
  planAt: "Thời gian dự kiến",
  finishedAt: "Thời gian hoàn thành",
  remark: "Ghi chú",
  detail: "Chi tiết",
  add: "Thêm",
  saveOk: "Lưu thành công",
  saveErr: "Lưu thất bại",
  del: "Xóa",
  delOk: "Xóa thành công",
  delErr: "Xóa thất bại",
  cancel: "Hủy",
  cancelTip: "Bạn có chắc chắn muốn hủy đơn kiểm tra này không?",
  cancelOk: "Hủy thành công",
  cancelErr: "Hủy thất bại",
  notE: "Không tồn tại",
  exist: "Tồn tại",
  partE: "Tồn tại một phần",
  notS: "Không đạt",
  suitable: "Đạt",
  partS: "Đạt một phần",
  notInspect: "Chưa kiểm tra",
  config: "Cấu hình kiểm tra",
  needInspection: "Có cần kiểm tra không",
  cycleDays: "Chu kỳ kiểm tra (ngày)",
  cycleDaysPlaceholder: "Để trống nếu không định kỳ/theo yêu cầu",
  content: "Mô tả nội dung kiểm tra",
  yes: "Có",
  no: "Không",
  day: "Ngày",
  plsSelectIns: "Vui lòng chọn có cần kiểm tra không",
  finish: "Hoàn thành",
  finishTip: "Bạn có chắc chắn hoàn thành đơn kiểm tra này không?",
  finishOk: "Đơn kiểm tra đã hoàn thành",
  finishErr: "Hoàn thành thất bại",
  inspector: "Người kiểm tra",
  locationCode: "Mã vị trí kho",
  existenceState: "Trạng thái tồn tại",
  complianceState: "Mức độ phù hợp",
  action: "Biện pháp xử lý",
  inspectedAt: "Thời gian kiểm tra",
  addOrder: "Thêm đơn kiểm tra",
  plProduct: "Vui lòng chọn vật liệu cần kiểm tra",
  plPlanAt: "Vui lòng chọn thời gian kiểm tra",
  addProduct: "Thêm vật liệu",
  redPro: "Vật liệu được đánh dấu đỏ không có cấu hình kiểm tra",
  inspectProgress: "Tiến độ kiểm tra",
  inspectItem: "Hạng mục kiểm tra",
  attechment: "Tệp đính kèm kiểm tra",
  submitInspect: "Gửi kiểm tra",
  submitSucc: "Gửi kiểm tra thành công",
  submitFail: "Gửi kiểm tra thất bại",
  inspect: "Kiểm tra",
  specialHandlingAggregate: "Trạng thái môi trường bảo quản",
  specialHandlingState: "Khôi phục môi trường bảo quản",
  specialHandlingRemark: "Ghi chú",
  notSx: "Không theo yêu cầu",
  suitablex: "Theo yêu cầu",
  partSx: "Một phần theo yêu cầu",
  notInspectx: "Không cần xử lý",
  unFinish: "Có hạng mục kiểm tra chưa được kiểm tra, không thể hoàn thành",
  orderCanceled: "Đơn kiểm tra này đã bị hủy, lưu kiểm tra thất bại",
  orderFinished: "Đơn kiểm tra này đã hoàn thành, lưu kiểm tra thất bại",
  configExsist: "Loại yêu cầu này đã tồn tại, không cần thêm",
};

export default inspection;
